import React from 'react';
import './FactionDemonsDescription.css';
import {
  DEMONS_ABILITY_RANGE,
  DEMONS_AMOUNT_FACTOR,
  DEMONS_COMBAT_BONUS_DEBUFF
} from "../../../../configs/factions/demons";
import {MINUS_SIGN} from "../../../../constants/text";
import DescriptionValueWithIcon from "../../../PolicyCardOverlay/DescriptionValueWithIcon/DescriptionValueWithIcon";

const FactionDemonsDescription = () => {
  const size = <img
    className="faction-description-icon"
    src="/img/icons/unit size.png"
    alt="Размер отряда"
    title={'Размер отряда'}
  />;
  const melee = <img
    className="faction-description-icon faction-description-icon-margin-right-left"
    src="/img/icons/barracks red.png"
    alt="Ближний бой"
    title={'Ближний бой'}
  />;
  const shooting = <img
    className="faction-description-icon faction-description-icon-margin-left" src="/img/icons/shooting.png"
    alt="стрельба"
    title={'Стрельба'}
  />;

  const sizeMarginLeft = <img
    className="faction-description-icon faction-description-icon-margin-left"
    src="/img/icons/unit size.png"
    alt="Размер отряда"
    title={'Размер отряда'}
  />;

  const unit = <img
    className={'policy-description-icon-unit policy-description-icon-unit-margin-right-left'}
    src={'/img/icons/unit d6 friend.png'}
    alt={'Отряд'}
    title={'Отряд'}
  />;
  const unitEnemy = <img
    className={'policy-description-icon-unit policy-description-icon-unit-margin-right-left'}
    src={'/img/icons/unit d6 enemy.png'}
    alt={'Отряд противника'}
    title={'Отряд противника'}
  />;

  const dice = <img
    className={'policy-description-icon policy-description-icon-margin-right-left'}
    src={'/img/icons/dice red.png'}
    alt={'Бросок кости'}
    title={'Бросок кости'}
  />;

  const sizeValueAndIcon = <DescriptionValueWithIcon
    className={'policy-description-icon-margin-right-left'}
    value={DEMONS_AMOUNT_FACTOR}
    icon={size}
  />

  const distance = <img
    className={'policy-description-icon'}
    src={'/img/icons/distance.png'}
    alt={'Дальность'}
    title={'Дальность'}
  />;

  const distanceValueAndIcon = <DescriptionValueWithIcon
    className={'policy-description-icon-margin-left-end'}
    value={distance}
    icon={DEMONS_ABILITY_RANGE}
  />

  return (
    <>
      <div className="policy-description_line">
        Вражеский {unitEnemy} имеет
        <span className={'text-war policy-description-icon-margin-right-left'}>
          {MINUS_SIGN}{Math.abs(DEMONS_COMBAT_BONUS_DEBUFF)}
        </span>
        к {dice} в {melee} и {shooting}
      </div>
      <div className="policy-description_line">
        за каждые {sizeValueAndIcon} от суммарного {sizeMarginLeft}
      </div>
      <div className="policy-description_line">
        всех {unit} игрока-демона на {distanceValueAndIcon}.
      </div>
    </>
  );
};

export default FactionDemonsDescription;
